import React from 'react';
import {LinkButton} from '@backstage/core-components';

import {Typography,Card,CardMedia,CardContent,CardActions,Box,Chip } from '@material-ui/core';
interface FeatureCardProps {
    title: string;
    description: string;
    link: string;
    tags: string[];
    icon?: string;
  }

export const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon, link, tags }) => {
  return (
    <Card style={{ maxWidth: "350px", width: "50%", marginBottom: 20, minHeight: "340px", padding: 0, margin: 0 }}>
        <CardMedia
          component="img"
          alt="ascentt"
          height="60"
          image={icon}
          style={{ objectFit: 'contain' }}
        />
        <CardContent>
        <Typography gutterBottom variant="h6" component="div">
            {title}
        </Typography>
        <Typography variant="body2" style={{ color: 'text.secondary' }}>
            {description}
        </Typography>
        <Box mt={2} display="flex" flexWrap="wrap">
            {tags.map((tag, index) => (
              <Chip key={index} label={tag} size="small" />
            ))}
        </Box>
        </CardContent>
        <CardActions>
        <LinkButton color="primary" style={{fontWeight:'bold'}} to={link}>
            EXPLORE
        </LinkButton>
        </CardActions>
  </Card>
  );
};

